module.exports = __webpack_public_path__ + "static/media/sd.11c4b40e.svg";